import client from 'helpers/client';
import cognito from 'helpers/cognito';

export const getPaymentRequestByMemoHash = async (memoHash) => {
  try {
    const response = await client.api(`/payment-requests/by-memo/${memoHash}`, 'get');
    return response.data;
  } catch (error) {
    console.error('Error getting payment request by memo hash:', error);
    throw error;
  }
};

export const getPaymentRequests = async (filters = {}) => {
  try {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, value);
      }
    });

    const query = params.toString();
    const response = await client.api(`/payment-requests${query ? `?${query}` : ''}`, 'get', {
      headers: await cognito.getHeaderAuthorization(),
    });

    return response.data;
  } catch (error) {
    console.error('Error getting payment requests:', error);
    throw error;
  }
};

export const getRevenueItems = async (filters = {}) => {
  try {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, value);
      }
    });

    const query = params.toString();
    const response = await client.api(`/revenue-items${query ? `?${query}` : ''}`, 'get', {
      headers: await cognito.getHeaderAuthorization(),
    });

    return response.data;
  } catch (error) {
    console.error('Error getting revenue items:', error);
    throw error;
  }
};

export const createPaymentRequest = async (body) => {
  try {
    const response = await client.api('/payment-requests', 'post', body, {
      headers: await cognito.getHeaderAuthorization(),
    });
    return response.data;
  } catch (error) {
    console.error('Error creating payment request:', error);
    throw error;
  }
};

export const updateDaoVaultAddress = async (daoId, vaultAddress) => {
  try {
    const response = await client.api(
      `/daos/${daoId}`,
      'put',
      { vaultAddress },
      {
        headers: await cognito.getHeaderAuthorization(),
      },
    );
    return response.data;
  } catch (error) {
    console.error('Error updating DAO vault address:', error);
    throw error;
  }
};

/**
 * Submit on-chain payment proof after a successful blockchain transaction.
 * No auth required.
 * @param {string} memoHash
 * @param {string} txHash
 * @param {string} buyerEmail
 * @param {number} chainId
 * @returns {Promise<{ success: boolean, data: { paymentRequestStatus: string, revenueItemId?: string }, error: object|null }>}
 */
export const submitOnchainPayment = async ({ memoHash, txHash, chainId, buyerEmail }) => {
  try {
    const response = await client.api('/payment-requests/submit-onchain-payment', 'post', {
      memoHash,
      txHash,
      chainId,
      buyerEmail,
    });
    return response.data;
  } catch (error) {
    console.error('Error submitting on-chain payment proof:', error);
    throw error;
  }
};

export default {
  getPaymentRequestByMemoHash,
  getPaymentRequests,
  getRevenueItems,
  createPaymentRequest,
  updateDaoVaultAddress,
  submitOnchainPayment,
};
